import PropTypes from 'prop-types';
import baseColorData from '../data/baseColorData';
var baseColor = PropTypes.oneOf(baseColorData);
export default {
  baseColor: baseColor
};